'use strict'

// A sample component

const Header = {
    init: function () {
        if (document.querySelector('.header__wrapper')) {
            this.toggleMenuMobile();
            this.stickyNavbar();

            window.addEventListener('resize', function () {
                if (window.innerWidth > 991) {
                    document.querySelector('body').style.position = "relative";
                }
            })
        }
    },
    toggleMenuMobile: function () {
        const burgerBtnMobile = document.querySelector('.js-burger-mobile');
        const navbarContainer = document.querySelector('.header__wrapper');;
        burgerBtnMobile.addEventListener('click', () => {
            if (navbarContainer.classList.contains('open-mobile')) {
                navbarContainer.classList.remove('open-mobile');
                document.querySelector('body').style.position = "relative";
            } else {
                navbarContainer.classList.add('open-mobile');
            }

        })
    },
    stickyNavbar: function () {
        const navbar = document.querySelector('.header__wrapper');
        if (!document.querySelector('.js-banner')) {
            navbar.classList.add('sticky');
            document.querySelector('.main').classList.add('no-banner');
        }
        document.addEventListener('scroll', () => {
            var scrolled = document.scrollingElement.scrollTop;
            var position = navbar.offsetTop;
            if (scrolled > position + 100) {
                navbar.classList.add('sticky');
            } else if (document.querySelector('.js-banner')) {
                navbar.classList.remove('sticky');
            }
            if (navbar.classList.contains('open-mobile') && window.innerWidth < 991) {
                document.querySelector('body').style.position = "fixed";
            } else {
                document.querySelector('body').style.position = "relative";
            }
        })
    },
}


export default Header;
